import React, { memo } from "react";
import { styled } from "@mui/system";
import { Box, Button, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Iconify from "../../../components/Iconify";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";

const GradientCard = styled(motion.div)(({ gradient }) => ({
  backgroundImage: gradient || "linear-gradient(to right, #725AC1,#8D86C9)",
  padding: "20px",
  borderRadius: "15px",
  cursor: "pointer",
  display: "flex",
  position: "relative",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "6px 6px 4px 0 black",
  },
  minHeight: 120,
}));

const AssetDashcard = memo(
  ({ count, color, icon, title, navigation, gradient, productStatus }) => {
    const navigate = useNavigate();

    const handlenavigate = () => {
      if (productStatus == "InStock") {
        navigate(`/asset-management/sale`);
      } else {
        navigate(`/asset-management/purchase?productstatus=${productStatus}`);
      }
    };
    return (
      <Box
        sx={{
          width: "100%",
          position: "relative",
          mb: 4,
        }}
      >
        <GradientCard
          gradient={gradient}
          initial={{ y: -200, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "-30px",
              left: "0px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: `2px solid ${color}`,
              width: "60px",
              borderRadius: "30px",
              backgroundColor: "#fff",
            }}
          >
            <Icon icon={icon} width={30} height={30} color={color} />
          </Box>
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 700,
            }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                px: "8px",
                py: "5px",
                mt: 2,
              }}
            >
              <Typography
                sx={{
                  color: color,
                  fontWeight: 700,
                }}
              >
                {count}
              </Typography>
            </Box>
            {navigation ? null : (
              <Button
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  height: "30px",
                  width: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                }}
                onClick={() => handlenavigate()}
              >
                <Icon
                  icon={"ic:round-search"}
                  width={20}
                  height={20}
                  color={color}
                />
              </Button>
            )}
          </Box>
        </GradientCard>
      </Box>
    );
  }
);

export default AssetDashcard;
